import { Modal } from 'antd';
import 'antd/dist/antd.css';
import { toast } from '../../helpers';
import { useAppDispatch, useAppSelector } from 'hooks';
import i18n from 'locales/i18n';
import {
  BillTypes,
  Cart,
  MenuCategory,
  Product,
  ProductParams,
  ServiceType,
  SetMenu,
} from 'models';
import { ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { authAction } from 'redux/slices/authSlice';
import { billAction } from 'redux/slices/billSlice';
import { menuAction } from 'redux/slices/menuSlice';
import { shopAction } from 'redux/slices/shopSlice';
import {
  checkSettingCustom,
  getSelectedProductOptions,
  getShopAvatarUrl,
  useDebounce,
} from 'utils';
import DefaultShopLogo from '../../assets/images/default_shop_logo.png';
import * as svg from '../../constants/ui/svg';
import BillSelector from './component/BillSelector';
import MenuTab from './component/MenuTab';
import ModalCart from './component/ModalCart';
import ModalSelectOptionProduct from './component/ModalSelectOptionProduct';
import SetTab from './component/SetTab';
import { DEFAULT_APP_NAME } from '../../constants';

// Socket
import * as socket from '../../sockets';
import { settingsAction } from 'redux/slices/settingsSlice';

const MenuPage = () => {
  const { t } = useTranslation();
  const router = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const searchParams = new URLSearchParams(router.search);

  const shop_id = Number(searchParams.get('shop_id'));
  const table_id = Number(searchParams.get('table_id'));
  const bill_id = Number(searchParams.get('bill_id'));
  const tab = searchParams.get('tab');
  const set_id = searchParams.get('set_id');
  const category_id = searchParams.get('category_id');

  const urlShowBill = `/show-bill?shop_id=${shop_id}&table_id=${table_id}${
    bill_id ? `&bill_id=${bill_id}` : ''
  }`;

  const menuCategoryList: Array<MenuCategory> = useAppSelector(
    (state) => state.menu.menuCategoryList
  );
  const menuProductByCategoryList: Array<Product> = useAppSelector(
    (state) => state.menu.menuProductList
  );
  const menuProductCategoryLoading: boolean = useAppSelector(
    (state) => state.menu.menuProductLoading
  );

  const token_order = useAppSelector((state) => state.auth.token_order) || '';
  const menuSetList: Array<SetMenu> = useAppSelector((state) => state.menu.menuSetList);
  const shopInfo: any = useAppSelector((state) => state.shop.shopInfo);
  const billInfo: BillTypes = useAppSelector((state) => state.bill.billInfo);
  const billListByTable = useAppSelector((state) => state.bill.billListByTable);
  const isOrderSuccess = useAppSelector((state) => state.bill.isOrderSuccess);
  const settingsShopCustom = useAppSelector((state) => state.settings.settingsShopCustom);
  const listServices = useAppSelector((state) => state.settings.listServices);
  const isRestaurant = shopInfo?.career?.name === 'RESTAURANT';
  // 18/8/2025, Hide set menu tab, add shop id into array to show set menu for specific shop
  // const shopsHideSetMenu = [460, 462, 34];
  // const checkShopShouldHideMenu = !shopsHideSetMenu.includes(shopInfo?.id);

  // 31/10/2025, handle dynamic shop should show/hide set menu
  const handleCheckShopShouldHideMenuNew = useCallback(() => {
    const findSettingShowSetMenuWebMenu = settingsShopCustom.find(
      (item) => item.name == 'show_set_menu_web_menu'
    );
    // if shop food always return false
    if (shopInfo.food == 1) return false;
    return Boolean(
      findSettingShowSetMenuWebMenu?.active &&
      JSON.parse(String(findSettingShowSetMenuWebMenu.app_name || '[]')).includes(9)
    );
  }, [settingsShopCustom.length, shopInfo.food]);
  const checkShopShouldHideMenu = handleCheckShopShouldHideMenuNew();
  // const checkShopShouldHideMenu = true;
  const searchButtonRef = useRef<HTMLDivElement | null>(null);
  const [selectedTab, setSelectedTab] = useState(tab ? tab : 'menu');
  const [isExpandSearch, setIsExpandSearch] = useState<boolean>(false);
  const [showCallStaffModal, setShowCallStaffModal] = useState<boolean>(false);
  const [selectedService, setSelectedService] = useState<any>(null);
  const [selectedParent, setSelectedParent] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState({} as MenuCategory);
  const [selectedSetOption, setSelectedSetOption] = useState({} as SetMenu);
  const [searchKey, setSearchKey] = useState('');
  const [showOrderConfirmationModal, setShowOrderConfirmationModal] = useState<boolean>(false);
  const [cartList, setCartList] = useState<Array<Cart>>([]);
  const [showSelectOptionProductModal, setShowSelectOptionProductModal] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [loadingCart, setLoadingCart] = useState(false);
  const [isLayoutBillGroup, setIsLayoutBillGroup] = useState<boolean>(false);

  const isOrdered =
    checkSettingCustom({
      settingsShopCustom,
      check: 'show_order_web_order',
    }) && Boolean(billInfo.id);
  console.log('cartList: ', cartList);
  const isPreviewMenuInBillGroup = billListByTable.length > 0;
  // check that table has bill in billInfo.id
  // check that table has allow hide_payment_web_menu in checkSettingCustom
  const isShowPaymentPage =
    !checkSettingCustom({
      settingsShopCustom,
      check: 'hide_payment_web_menu', // hide payment
    }) && Boolean(billInfo.id);
  // Realtime
  useEffect(() => {
    if (shop_id) {
      const old_shop_id = localStorage.getItem('POS_QR_SELECTED_SHOP');

      if (`${shop_id}` !== old_shop_id) {
        socket.clientJoinRoom({
          shop_id: shop_id,
          old_shop_id,
        });
      } else {
        socket.clientJoinRoom({
          shop_id: shop_id,
        });
      }
      localStorage.setItem('POS_QR_SELECTED_SHOP', `${shop_id}`);
    }
  }, [shop_id]);
  useEffect(() => {
    // 31/10/2025, remove token order
    if (shop_id) {
      dispatch(
        settingsAction.getSettingsShopCustom({
          shop_id,
          bill_id: billInfo.id,
          appName: DEFAULT_APP_NAME,
        })
      );
      dispatch(settingsAction.getServices({ shop_id, appName: DEFAULT_APP_NAME }));
    }
  }, [token_order, shop_id, dispatch, billInfo.id]);

  const handleGetProductBySelectedCategory = useCallback(() => {
    console.log('selected cate: ', selectedCategory);
    if (selectedCategory?.id) {
      const requestPayload: ProductParams = {
        cid_category: selectedCategory.id,
        page: 1,
        per_page: 3000,
        shopId: shop_id,
        sort_type: 0,
        type_get: 'all',
        appName: DEFAULT_APP_NAME,
      };
      if (searchKey) {
        requestPayload.key = searchKey;
      }
      dispatch(menuAction.getMenuProductList(requestPayload));
    }
  }, [selectedCategory?.id, searchKey]);

  const handleSelectCategory = (category: MenuCategory) => {
    setSelectedCategory(category);
    if (searchKey !== '') {
      setSearchKey('');
    }
    if (searchParams.has('category_id')) {
      searchParams.set('category_id', String(category.id));
    } else {
      searchParams.append('category_id', String(category.id));
    }
    const newUrl = `${router.pathname}?${searchParams}`;
    history.replace(newUrl);
  };

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchKey(value);
    // If in set tab, return to menu tab
    if (selectedTab == 'set') {
      setSelectedTab('menu');
    }
  };
  const handleDebounceSearchKeyChange = useDebounce(handleSearchChange, 300);

  const handleToggleTab = (selectedTab: 'menu' | 'set') => {
    if (searchParams.has('set_id')) {
      searchParams.delete('set_id');
    }
    if (searchParams.has('category_id')) {
      searchParams.delete('category_id');
    }
    if (searchParams.has('tab')) {
      searchParams.set('tab', selectedTab);
    } else {
      searchParams.append('tab', selectedTab);
    }
    const newUrl = `${router.pathname}?${searchParams}`;
    history.replace(newUrl);

    setSelectedTab(selectedTab);
  };

  const filteredCategories = useMemo(() => {
    return [...menuCategoryList]
      .sort((a, b) => b.orderby - a.orderby)
      .filter((item) => {
        if (item.parent_id !== selectedParent?.id || item.status === 0) return false;
        const disableApp = JSON.parse(String(item.disable_app || '[]'));
        return !disableApp.includes(9);
      });
  }, [menuCategoryList, selectedParent?.id]);

  const sortedMenuSetList = useMemo(() => {
    return [...menuSetList].sort((a, b) => {
      return a.orderby - b.orderby;
    });
  }, [menuSetList]);

  const handleCallStaffButton = () => {
    if (selectedService.service_id && selectedService.service_id !== null && token_order) {
      dispatch(
        settingsAction.callStaffServices({
          token: token_order,
          data: { ...selectedService, token_order },
          appName: DEFAULT_APP_NAME,
        })
      );
      setShowCallStaffModal(false);
      setSelectedService(null);
    }
  };
  const handleSelectedService = (serviceITem: ServiceType) => {
    const data = {
      shop_id: shop_id,
      service_id: serviceITem?.id,
      status_working: 0,
      table_id: billInfo.tables.id,
      creator_id: billInfo.creator_id,
      main_id:
        billInfo.service_fee.length > 0
          ? billInfo.service_fee.find((item) => item.type === 1)?.user_of_shop?.cid_user || null
          : null,
      bill_id: billInfo?.id,
    };
    setSelectedService(data);
  };
  const handleCartButtonClick = () => {
    setShowOrderConfirmationModal(true);
  };

  const handleAddToCart = (product: Product, option: any = []) => {
    setCartList((prevCart) => {
      const VAT = (billInfo?.tax || 0) + (billInfo?.consumption_tax || 0);
      const updatedCart = [...prevCart];
      const productOptions =
        getSelectedProductOptions(product?.product_options, option, 'price') || 0;
      const productBasePrice = product.price || 0;
      const quantity = product.quantity || 1;
      const amount = (productOptions + productBasePrice) * quantity;
      const vat_money = ((productOptions + productBasePrice) * quantity * VAT) / 100;
      const index = updatedCart?.findIndex((item) => item.id === product.id);
      if (index !== -1) {
        const currentQuantity = updatedCart[index].quantity;
        const newQuantity = currentQuantity + 1;
        const newAmount = (productOptions + productBasePrice) * newQuantity;
        const newVatMoney = ((productOptions + productBasePrice) * newQuantity * VAT) / 100;
        updatedCart[index] = {
          ...updatedCart[index],
          selected_options: option,
          quantity: newQuantity,
          price: productBasePrice,
          amount: newAmount,
          vat_money: isRestaurant ? newVatMoney : null,
          price_no_vat: isRestaurant ? newAmount - newVatMoney : null,
        };
      } else {
        updatedCart.push({
          ...product,
          selected_options: option,
          quantity,
          price: productBasePrice,
          amount,
          vat_money: isRestaurant ? vat_money : null,
          price_no_vat: isRestaurant ? amount - vat_money : null,
          vat: isRestaurant ? VAT : 0,
        });
      }
      return updatedCart;
    });
  };

  const onDecrease = (item: Cart) => {
    const index = cartList?.findIndex((i) => i.id === item.id);
    try {
      if (cartList[index].quantity === 1) {
        cartList.splice(index, 1);
        setCartList([...cartList]);
      } else {
        cartList[index].quantity -= 1;
        const optionPrice = getSelectedProductOptions(
          item.product_options,
          cartList[index].selected_options,
          'price'
        );
        cartList[index].amount = (optionPrice + item.price) * cartList[index].quantity;
        if (isRestaurant) {
          const VAT = billInfo?.tax + billInfo?.consumption_tax;
          cartList[index].vat = VAT;
          cartList[index].vat_money = ((cartList[index].amount ?? 0) * VAT) / 100;
          if (cartList && cartList[index]) {
            cartList[index].price_no_vat =
              (cartList[index]?.amount ?? 0) - (cartList[index]?.vat_money ?? 0);
          }
        }
        setCartList([...cartList]);
      }
    } catch (error) {}
  };

  const onIncrease = (item: Cart) => {
    const index = cartList?.findIndex((i) => i.id === item.id);
    const VAT = billInfo?.tax + billInfo?.consumption_tax;

    if (cartList[index].quantity < (item.stock ?? 0) || `${item.active_stock}` === '0') {
      cartList[index].quantity += 1;
      const optionPrice = getSelectedProductOptions(
        item.product_options,
        cartList[index].selected_options,
        'price'
      );
      cartList[index].amount = (optionPrice + item.price) * cartList[index].quantity;
      if (isRestaurant) {
        cartList[index].vat = VAT;
        cartList[index].vat_money = ((cartList[index].amount ?? 0) * VAT) / 100;
        if (cartList && cartList[index]) {
          cartList[index].price_no_vat =
            (cartList[index]?.amount ?? 0) - (cartList[index]?.vat_money ?? 0);
        }
      }
      setCartList([...cartList]);
    } else {
      toast(i18n.t('SOLD_OUT_MESSAGE', { number: item.stock }), 'warning', 2000);
    }
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (searchButtonRef.current && !searchButtonRef.current.contains(e.target as Node)) {
      setIsExpandSearch(false);
    }
  };

  const addProductInBill = () => {
    if (cartList.length > 0) {
      setLoadingCart(true);
      const params = {
        appName: DEFAULT_APP_NAME,
        bill_id: billInfo.id,
        products: cartList.map((product: any) => ({
          app_name: 9,
          id: product.id,
          name: product.name,
          quantity: product.quantity,
          price: product.price,
          amount:
            ((product && product?.price) * product.quantity || 0) +
            (product.selected_options?.length > 0 ? product.selected_options[0]?.price : 0),
          selected_options: product.selected_options || null,
          type: 0,
          user_id: product?.user_id || 0,
          tax_calculated: product.tax_calculated,
          vat_calculated: product.vat_calculated,
          take_out: 0,
        })),
        shop_id: shop_id,
        table_id,
      };
      dispatch(
        billAction.addProductInBill({
          ...params,
          onSuccess: () => {
            setLoadingCart(false);
          },
          onErrors: () => {
            setLoadingCart(false);
          },
        })
      );
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (shop_id && (billInfo?.id || billListByTable.length === 0)) {
      dispatch(
        menuAction.getMenuCategoryList({
          shopId: shop_id,
          type_get: 'all',
          appName: DEFAULT_APP_NAME,
        })
      );
      dispatch(menuAction.getMenuSetList({ shop_id, appName: DEFAULT_APP_NAME }));
    }
  }, [shop_id, billInfo?.id, billListByTable.length, dispatch]);

  useEffect(() => {
    if (isOrderSuccess) {
      setCartList([]);
      setShowOrderConfirmationModal(false);
    }
  }, [isOrderSuccess]);

  useEffect(() => {
    if (shop_id) {
      dispatch(
        shopAction.getShopInfo({
          shop_id,
          appName: DEFAULT_APP_NAME,
        })
      );
    }
  }, [dispatch, shop_id]);

  useEffect(() => {
    if (filteredCategories.length) {
      if (category_id) {
        const findIndex = filteredCategories.findIndex((item) => item.id === Number(category_id));
        if (findIndex !== -1) {
          setSelectedCategory(filteredCategories[findIndex]);
        } else {
          if (searchParams.has('category_id')) {
            searchParams.set('category_id', String(filteredCategories[0].id));
          }
          const newUrl = `${router.pathname}?${searchParams}`;
          history.replace(newUrl);
          setSelectedCategory(filteredCategories[0]);
        }
      } else {
        setSelectedCategory(filteredCategories[0]);
      }
    }
  }, [filteredCategories.length, category_id, filteredCategories]);

  useEffect(() => {
    if (!sortedMenuSetList.length) return;

    if (set_id) {
      const selected =
        sortedMenuSetList.find((item) => item.id === Number(set_id)) ?? sortedMenuSetList[0];

      setSelectedSetOption(selected);
    } else {
      setSelectedSetOption(sortedMenuSetList[0]);
    }
  }, [sortedMenuSetList, set_id]);

  useEffect(() => {
    const main = menuCategoryList.filter((i) => i.is_main_menu);
    if (main.length > 0) {
      const lastMain = main[main.length - 1];
      setSelectedParent(lastMain);
    }
  }, [menuCategoryList, menuCategoryList.length]);

  // useEffect(() => {
  //   if (billInfo?.id || billListByTable.length === 0) {
  //     handleGetProductBySelectedCategory();
  //   }
  // }, [billInfo?.id, billListByTable.length, handleGetProductBySelectedCategory]);
  useEffect(() => {
    handleGetProductBySelectedCategory();
  }, [handleGetProductBySelectedCategory]);

  useEffect(() => {
    dispatch(billAction.getBillByTable({ table_id, shop_id, appName: DEFAULT_APP_NAME }));
  }, [dispatch, shop_id, table_id]);

  useEffect(() => {
    if (billInfo?.id) {
      dispatch(
        authAction.getTokenOrder({
          bill_id: billInfo.id,
          table_id,
          shop_id,
          appName: DEFAULT_APP_NAME,
        })
      );
    }
  }, [billInfo.id, dispatch, shop_id, table_id]);

  if (bill_id) {
    const billDetailByBillId = billListByTable.find((item) => item.id === bill_id);
    if (billDetailByBillId) {
      dispatch(billAction.setBillInfo(billDetailByBillId));
    }
  }
  // if (!billInfo.id && billListByTable.length > 0) {
  //   return <BillSelector />;
  // }
  if (isLayoutBillGroup) {
    return <BillSelector setIsLayoutBillGroup={setIsLayoutBillGroup} />;
  }
  return (
    <div className="w-full bg-white">
      <div className="flex items-center justify-between w-full p-2 px-3 menu-header">
        <div className="flex gap-x-4">
          {isPreviewMenuInBillGroup && (
            <button
              onClick={() => {
                setIsLayoutBillGroup(true);
                if (billInfo?.id) {
                  dispatch(billAction.setBillInfo({}));
                }
                if (cartList.length && cartList.length > 0) {
                  setCartList([]);
                }
              }}
              className="w-5 flex items-center justify-center scale-150"
            >
              {svg.chevronLeftIcon}
            </button>
          )}
          <img
            src={getShopAvatarUrl('small', shopInfo.avatar_image)}
            alt="Shop avatar"
            className="h-[38px] w-16 rounded-lg object-cover"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = DefaultShopLogo;
            }}
          />
        </div>
        <div className="flex items-center gap-2">
          {shopInfo?.food !== 1 && listServices.length > 0 && billInfo?.id ? (
            <button
              onClick={() => setShowCallStaffModal(!showCallStaffModal)}
              className="flex items-center p-2 border border-solid rounded-full border-border_primary"
            >
              {svg.callStaffIcon}
            </button>
          ) : (
            <></>
          )}
          <div
            className="border border-border_primary rounded-full flex items-center gap-x-2 p-2 font-[NotoSans] text-sm"
            ref={searchButtonRef}
          >
            {isExpandSearch && (
              <input
                type="text"
                name="search"
                className="outline-none max-w-[120px] w-full"
                placeholder={t('SEARCH_FOR_PRODUCTS')}
                onChange={(e) => handleDebounceSearchKeyChange(e)}
              />
            )}
            <button onClick={() => setIsExpandSearch(!isExpandSearch)}>{svg.searchIcon}</button>
          </div>
        </div>
      </div>
      <div className="w-full menu-tab border-y border-border_primary">
        <button
          onClick={() => handleToggleTab('menu')}
          className={`${checkShopShouldHideMenu ? 'w-1/2' : 'w-full'} h-[50px] ${
            selectedTab == 'menu' &&
            'text-primary border-b-[3px] border-solid border-primary font-bold'
          }`}
        >
          {t('MENU')}
        </button>
        {checkShopShouldHideMenu && (
          <button
            onClick={() => handleToggleTab('set')}
            className={`w-1/2 h-[50px] ${
              selectedTab == 'set' &&
              'text-primary border-b-[3px] border-solid border-primary font-bold'
            }`}
          >
            {t('SET')}
          </button>
        )}
      </div>
      <div className="menu-body flex h-[calc(100vh-108px)]">
        {selectedTab == 'menu' ? (
          <MenuTab
            handleSelectCategory={handleSelectCategory}
            menuCategoryList={filteredCategories}
            menuProductByCategoryList={menuProductByCategoryList}
            menuProductCategoryLoading={menuProductCategoryLoading}
            selectedCategory={selectedCategory}
            cart={cartList}
            setCart={setCartList}
            onDecrease={onDecrease}
            onIncrease={onIncrease}
            isRestaurant={isRestaurant}
            handleAddToCart={handleAddToCart}
            setShowSelectOptionProductModal={setShowSelectOptionProductModal}
            setSelectedProduct={setSelectedProduct}
          />
        ) : (
          <SetTab
            menuSetList={menuSetList}
            selectedSetOption={selectedSetOption}
            setSelectedSetOption={setSelectedSetOption}
          />
        )}
      </div>
      <Modal
        open={showCallStaffModal}
        onCancel={() => setShowCallStaffModal(false)}
        closeIcon={<></>}
        footer={null}
        centered
        width={343}
        className="call-staff-modal"
      >
        <div>
          <div className="flex items-center justify-between px-4 py-3">
            <span className="text-xl font-bold text-brown_dark font-noto-sans-bold">
              {t('CALLING_STORE_STAFF')}
            </span>
            <button
              onClick={() => setShowCallStaffModal(false)}
              className='font-medium text-primary font-noto-sans-medium"'
            >
              {t('CLOSE')}
            </button>
          </div>
          <div className="grid grid-cols-2 gap-2 p-2 border-t border-border_primary">
            {listServices.length > 0 &&
              listServices.map((item, index) => (
                <button
                  key={index}
                  onClick={() => handleSelectedService(item)}
                  className={`${
                    selectedService?.service_id == item.id
                      ? '!text-white !bg-primary'
                      : 'text-primary'
                  } rounded-lg font-noto-sans-medium font-medium text-lg border border-solid border-border_primary aspect-square`}
                >
                  {item.name || ''}
                </button>
              ))}
          </div>
          <div className="p-2 border-t border-border_primary">
            <button
              className="w-full h-[50px] bg-primary text-white rounded-lg font-noto-sans-medium"
              onClick={handleCallStaffButton}
            >
              {t('CALL_STAFF')}
            </button>
          </div>
        </div>
      </Modal>

      <ModalCart
        open={showOrderConfirmationModal}
        setOpen={setShowOrderConfirmationModal}
        cart={cartList}
        setCart={setCartList}
        onDecrease={onDecrease}
        onIncrease={onIncrease}
        addProductInBill={addProductInBill}
        loadingCart={loadingCart}
        setLoadingCart={setLoadingCart}
      />

      <ModalSelectOptionProduct
        open={showSelectOptionProductModal}
        setOpen={setShowSelectOptionProductModal}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        handleAddToCart={handleAddToCart}
      />
      {isShowPaymentPage && (
        <Link
          to={urlShowBill}
          className={`flex flex-col items-center justify-center bg-white gap-y-1 font-[NotoSans] font-medium text-primary text-xs text-center fixed bottom-4 ${
            isOrdered ? 'right-20' : 'right-4'
          } w-[60px] h-[60px] border border-solid border-primary rounded-full`}
        >
          <span>{svg.showBillIcon}</span>
          {t('BILL')}
        </Link>
      )}
      {isOrdered && (
        // <button
        //   onClick={handleCartButtonClick}
        //   className="flex flex-col items-center justify-center bg-primary gap-y-1 font-[NotoSans] font-medium text-white text-xs text-center fixed bottom-4 right-4 w-[60px] h-[60px] border border-solid border-primary rounded-full"
        // >
        //   <span>{svg.cartIcon}</span>
        // </button>
        <button
          onClick={handleCartButtonClick}
          className="flex flex-col items-center justify-center bg-primary gap-y-1 font-[NotoSans] font-medium text-white text-xs text-center fixed bottom-4 right-4 w-[60px] h-[60px] border border-solid border-primary rounded-full"
        >
          <span>{svg.cartIcon}</span>
          <span className="absolute top-[9px] right-2 flex items-center justify-center size-4 bg-white text-primary text-[10px] font-bold rounded-full shadow-md">
            {cartList?.length}
          </span>
        </button>
      )}
    </div>
  );
};

export default MenuPage;
